/**
 * LogoMark — marca de "Regulatorio" (US-UATR2-26).
 *
 * Glifo propio (documento regulatorio con check de aprobación) dibujado con
 * `currentColor`, para que herede el color del contenedor (blanco en el menú y
 * el panel de login, azul de marca en el login móvil). Reemplaza el ícono
 * genérico de librería. Es un placeholder institucional hasta recibir el SVG
 * oficial del cliente; al llegar, solo se cambia este componente.
 */
interface LogoMarkProps {
  size?: number
  className?: string
  strokeWidth?: number
}

export function LogoMark({ size = 24, className, strokeWidth = 1.9 }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role="img"
      aria-label="Regulatorio"
    >
      {/* Documento regulatorio con esquina plegada */}
      <path d="M7 3h6.5L18 7.5V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      <path d="M13 3v4h4" />
      {/* Check de aprobación */}
      <path d="M8.3 13.6l2.3 2.3 4.4-4.9" />
    </svg>
  )
}
